import * as Constants from "../utils/constants";
import axios from "axios";

export const getForecast = async (data) => {
  try {
    const response = await axios.post(
      Constants.RECOMMENDATIONS,
      data,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch forecast");
  }
};

export const getCorrelation = async (data) => {
  try {
    const response = await axios.post(
      Constants.CORRELATION,
      data,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch correlation analysis");
  }
};

export const getNutsInventory = async (toYear, category) => {
  try {
    const response = await axios.get(Constants.NUTS_INVENTORY, {
      ...Constants.CONFIG,
      params: { toYear, category },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || "Failed to fetch NUTS inventory");
  }
};
